"use client";

import {
  Button,
  Item,
  ItemActions,
  ItemContent,
  ItemMedia,
  ItemTitle,
} from "../atoms";
import { UserAvatar } from "./user-avatar";

export type UserAreaProps = React.ComponentProps<typeof Item> & {
  user: {
    name?: string | null;
    email?: string | null;
    image?: string | null;
  };
  onSignOut?: () => void;
};

export function UserArea({ user, onSignOut, ...rest }: UserAreaProps) {
  return (
    <Item {...rest}>
      <ItemMedia>
        <UserAvatar user={user} />
      </ItemMedia>
      <ItemContent>
        <ItemTitle>{user.name ?? user.email}</ItemTitle>
      </ItemContent>
      <ItemActions className="flex flex-col items-stretch gap-2">
        <Button variant="link" onClick={onSignOut}>
          Sign out
        </Button>
      </ItemActions>
    </Item>
  );
}
